import React from 'react';
import { Button, FormControl, FormLabel, Input, HStack, Text } from 'components-lib';

const FileUploadField = ({
  label,
  id,
  name,
  onChange,
  selectedFile,
  helperText = 'Supported: JPG, PNG, PDF',
  accept = 'image/*',
  isDisabled = false,
  inputProps = {},
  appendText,
}) => (
  <FormControl>
    {label && <FormLabel>{label}</FormLabel>}
    <Input
      id={id}
      type="file"
      name={name}
      onChange={onChange}
      accept={accept}
      display="none"
      isDisabled={isDisabled}
      {...inputProps}
    />
    <HStack align="center" spacing={3} flexWrap="wrap">
      <Button
        as="label"
        htmlFor={id}
        bg="gray.200"
        color="gray.800"
        borderRadius="md"
        px={4}
        py={1}
        fontSize="sm"
        _hover={{ bg: 'gray.300' }}
        _active={{ bg: 'gray.400' }}
        isDisabled={isDisabled}
      >
        Choose File
      </Button>
      <Text fontSize="sm" color="gray.600" maxW="180px" isTruncated>
        {selectedFile ? selectedFile.name : 'No file chosen yet'}
      </Text>
    </HStack>
    {helperText && <Text fontSize="xs" color="gray.500" mt={1}>{helperText}</Text>}
  </FormControl>
);

export default FileUploadField;
